import $axios from "./index"

export function getInterpreterStatus() {
    return $axios({
        url: `/profile/exists/`,
        method: "get"
    })
}


export function whoAreYou() {
    return $axios({
        url: `/profile/me/`,
        method: 'get'
    })
}